export const getDayName = (date) => {
  return new Date(date).toLocaleDateString("en-US", { weekday: "long" });
};

export const formatAmount = (amount) => {
  const value = Number(amount);
  if (Number.isNaN(value)) return "₹" + amount;
  return "₹" + Math.round(value);
};
